import React from 'react';
import ServicePageShell from '../../components/ServicePageShell';
import MichveAlonStatic from './MichveAlonStatic';

export default function MichveAlon() {
  return (
    <ServicePageShell
      strapiApiId="annexe-michve-alon"
      defaultSectionLabel="Annexes"
      defaultTitle="Michve Alon"
      StaticFallback={MichveAlonStatic}
    />
  );
}
